interface ILocalStorageCart {
  expirationDate: Date;
  id: string;
}

export function setCartId(key: string, value: string, expirationInMin = 10) {
  console.log(key, value);

  window.localStorage.removeItem(key);
  let expirationDate = new Date(new Date().getTime() + 60000 * expirationInMin);
  let newValue: ILocalStorageCart = {
    id: value,
    expirationDate: expirationDate,
  };
  window.localStorage.setItem(key, JSON.stringify(newValue));
}

export function getCartId(key: string) {
  let stringValue = window.localStorage.getItem(key);
  if (stringValue) {
    let value: ILocalStorageCart = JSON.parse(stringValue);
    let expirationDate = new Date(value.expirationDate);
    if (expirationDate > new Date()) {
      return value.id;
    } else {
      window.localStorage.removeItem(key);
    }
  }
  return null;
}
